module.exports = __webpack_public_path__ + "img/Sony_Sunny.d50495a7.jpg";